"use client";

import React from "react";
import { Pills } from "@/components/common/pills/Pills";
import { useTranslation } from "@/lib/react/i18n";

export type AdminScope = "MINE" | "ALL";

type Props = {
  value: AdminScope;
  onChange: (next: AdminScope) => void;
  className?: string;
};

const AdminScopePills = ({ value, onChange, className }: Props) => {
  const { t } = useTranslation();

  const items = [
    { key: "MINE" as const, label: t("My contests") },
    { key: "ALL" as const, label: t("All contests") },
  ];

  return (
    <Pills<AdminScope>
      mode="single"
      items={items}
      selected={value}
      onChange={onChange}
      className={className}
    />
  );
};

export default AdminScopePills;